<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/',title:'首页'},{title:'测算版本列表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="创建时间" class="timeselect" style="width: 50%;">
								<el-date-picker
									v-model="q.startCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="q.endCdate"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
							<el-form-item label="版本状态">
							    <brselect category="cesuan_status" v-model="q.status" :v="q.status" :clearable="true"/>
							</el-form-item>

							<el-form-item label="区域">
							    <brselect category="neibu_haiwai_area" v-model="q.areaName" :v="q.areaName" :clearable="true"/>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="有效期" class="timeselect" style="width: 50%;">
										<el-date-picker
											v-model="q.startYXQ"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
											v-model="q.endYXQ"
											clearable
											type="date"
											value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
									<el-form-item label="客户名称/编码">
										<el-input v-model="q.customerId" :v="q.customerId"></el-input>
									</el-form-item>
									<el-form-item label="　创建人姓名">
										<el-input v-model="q.cuname"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
						</div>
					</div>
                </div>
            </div>

            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						:border="true"
                        style="width: 100%"
						max-height="500"
                >
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
							:show-overflow-tooltip="true"
                            min-width="180">
							<template slot-scope="scope">
							    <div style="text-align: left;">
									{{scope.row.projectName}}
								</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="areaName"
                            label="区域"
							:show-overflow-tooltip="true"
                            width="80">
                        <template slot-scope="scope">
                            {{scope.row.areaName | dictname('neibu_haiwai_area')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="customerId"
                            label="客户编码"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="customerName"
                            label="客户名称"
							:show-overflow-tooltip="true"
                            width="180">
							<template slot-scope="scope">
							    <div style="text-align: left;">
									{{scope.row.customerName}}
								</div>
							</template>
							<!-- <template slot-scope="scope">
							    <div style="text-align: left;">
									{{scope.row.projectName}}
								</div>
							</template> -->
                    </el-table-column>
                    <el-table-column
                            prop="cuname"
                            label="创建人名称"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="status"
							width="90"
                            label="版本状态">

                        <template slot-scope="scope">

                            {{scope.row.status | dictname('cesuan_status')}}

                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            value-format="yyyy-MM-dd"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="youxiaoqi"
                            label="有效期"
                            value-format="yyyy-MM-dd"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="specialId"
                            label="特价版本号"
							:show-overflow-tooltip="true"
                            width="160">
                        <template slot-scope="scope">
							<div style="text-align: left;">
								<span @click="clickspecialId(scope.row)">{{scope.row.specialId}}</span>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="240"
                    >
                        <template slot-scope="scope">

                            <div style="text-align: left;">
                            	<el-button
                            			style="padding: 0;"
                            	        type="text"
                            	        size="small"
                            	        class="h-tableLink h-btn"
                                        v-if="scope.row.instid"
                                        @click="genzongLiuch(scope.row)"
                            	>跟踪
                            	</el-button>
                            	<el-button
                            	style="padding: 0;"
                            	        type="text"
                            	        size="small"
                            	        class="h-tableLink h-btn"
                                @click="chakancesuan(scope.row)"
                            	        >查看
                            	</el-button>
                            	<el-button
                            	style="padding: 0;"
                            	        type="text"
                            	        size="small"
                            	        class="h-tableLink h-btn" @click="bianjicesuan(scope.row)"
                            	        v-if="scope.row.status == 0"
                            	>编辑
                            	</el-button>
                                <el-button
                                        style="padding: 0;"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="faqitejia(scope.row)"
                                        v-if="scope.row.status == 2 && scope.row.neixiaowaixiao == 1 && scope.row.specialId==null && scope.row.cucode ==_user.usercode && (scope.row.islengku ==0 || scope.row.islengku == null)">发起特价
                                </el-button>
                                <el-button
                                        style="padding: 0;"
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="chehui(scope.row)"
                                        v-if="scope.row.status == 1 && scope.row.neixiaowaixiao == 1 && scope.row.specialId==null&& scope.row.cucode ==_user.usercode">撤回
                                </el-button>
                            	<el-button
                            	style="padding: 0;"
                            	        type="text"
                            	        size="small"
                            	        class="h-tableLink h-btn"
                                v-if="scope.row.cucode == _user.usercode && (scope.row.status == 0 || scope.row.status == 3) "
                                @click="handleDelete(scope.row)"
                            	>删除
                            	</el-button>
                            </div>

							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="chakancesuan(scope.row)"></span>
								<span class="l-operationlist br-operation-xg" v-if="scope.row.status == 0" title="编辑" @click="chakancesuan(scope.row)"></span>
								<span class="l-operationlist br-operation-delete" title="删除" @click="handleDelete(scope.row)"></span>
								<span class="l-operationlist br-operation-spgz" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
							</div> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query"/>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="outexcel">导出</el-button>
                </div>
            </div>

			<viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile';
    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                showhistory:false,
                instid: '',
                moreCondition: false,

                timeYXQ:null,
                cdate:null,
                //查询属性
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    rversion: "", // 计算记录版本号
                    ispro: "", // 是否是项目   0不是  1是  2租赁测算
                    status: "", // 版本状态  0暂存  1提交  2审核通过  3驳回
                    cucode: "", // 创建人编码
                    cuname: "", // 创建人名称
                    cdate: "", // 创建时间
                    lucode: "", // 修改人编码
                    ldate: "", // 最后更新时间
                    neixiaowaixiao: "", // 内销还是外销   0内销  1外销   2租赁测算
                },

                //表单
                f: {
                    rversion: null, // 计算记录版本号
                    ispro: null, // 是否是项目   0不是  1是  2租赁测算
                    status: null, // 版本状态  0暂存  1提交  2审核通过  3驳回
                    cucode: null, // 创建人编码
                    cuname: null, // 创建人名称
                    cdate: null, // 创建时间
                    lucode: null, // 修改人编码
                    ldate: null, // 最后更新时间
                    neixiaowaixiao: null, // 内销还是外销   0内销  1外销   2租赁测算
                },

                //table列表
                tableData: [],

                //操作标志
                optflag: 'save',

            }
        },

        created() {

            this.query();

        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            //特价详情跳转
            clickspecialId(q){
                this.$router.push({ path: '/newprice' , query: {chakan: q.specialId}});
            },
            //重置
            chongzhi(){
                this.q.customerId=null;
                this.q.areaName=null;
                this.q.status=null;
                this.q.cuname=null;
                this.q.startYXQ=null;
                this.q.endYXQ=null;
                this.q.startCdate=null;
                this.q.endCdate=null;
                this.timeYXQ = null;
                this.cdate = null;
            },
            //有效期
            timeYXQSelect() {
                if (this.timeYXQ == null || this.timeYXQ == '') {
                    this.q.startYXQ = null;
                    this.q.endYXQ = null;
                } else {
                    this.q.startYXQ = this.timeYXQ[0];
                    this.q.endYXQ = this.timeYXQ[1];
                }
            },
            //创建日期
            timeSelect() {
                if (this.cdate == null || this.cdate == '') {
                    this.q.startCdate = null;
                    this.q.endCdate = null;
                } else {
                    this.q.startCdate = this.cdate[0];
                    this.q.endCdate = this.cdate[1];
                    console.log(this.q.startCdate)
                }
            },
            faqitejia(v) {
                this.$msg.confirm("确认发起特价申请?", () => {
                    var csid = {
                        rversion: v.rversion
                    }
                    ss.FormulaNew.chufatejiashenpi(csid).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg)
                            this.query();
                        } else {
                            this.$msg.msge(rd.msg)
                        }
                    })
                })
            },
            chehui(v) {
                this.$msg.confirm("确认撤回?", () => {
                    var csid = {
                        rversion: v.rversion
                    }
                    ss.FormulaNew.chehui(csid).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg)
                            this.query();
                        } else {
                            this.$msg.msge(rd.msg)
                        }
                    })
                })
            },
            bianji(v){
                this.$router.push({path: path, query: shiti});
            },
            genzongLiuch(v){
                console.log(v,"你好");
                this.instid = v.instid;
                this.showhistory = true;
            },
            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },



            //编辑测算
            bianjicesuan(q) {

                console.log(q, 'qqqq')

                var path = '';

                    //外销工具
                if (q.neixiaowaixiao == 1 && q.ispro == 0 && q.islengku ==0) {

					path = '/xiangmu/enterseven';

				}else if(q.neixiaowaixiao == 1 && q.ispro == 0 && q.islengku ==1){
				   path = '/xiangmu/enterlengku-wx';
				}else {
					  path = '/xiangmu/enterseven';
				}

                var shiti = {
                    bianjishiti: q.rversion
                }

                console.log(shiti, 'shitishitishiti')

                // //跳转查看
                 this.$router.push({path: path, query: shiti});

                // let routeData = this.$router.resolve({
                //     path: path,
                //     query: shiti
                // });
                // window.open(routeData.href, '_blank');

            },

            //查看测算
            chakancesuan(q) {

                console.log(q, 'qqqq')

                var path = '';

                //冷库
				if(q.islengku == 1) {

					path = '/xiangmu/enterlengku-wx';
				}else {
					 //内销
					if (q.neixiaowaixiao == 0 ) {

						path = '/xiangmu/enterfive';

					//外销项目
					} else if (q.neixiaowaixiao == 1 && q.ispro == 1) {

						path = '/xiangmu/entersix';

					//外销工具
					} else if (q.neixiaowaixiao == 1 && q.ispro == 0) {

						path = '/xiangmu/enterseven';

					//租赁
					} else if (q.neixiaowaixiao == 2) {

						path = '/rateFormulaZulinshiti';

					}
				}

                var shiti = {
                    chakanshiti: q.rversion
                }

                console.log(shiti, 'shitishitishiti')

                // //跳转查看
                 this.$router.push({path: path, query: shiti});

                // let routeData = this.$router.resolve({
                //     path: path,
                //     query: shiti
                // });
                // window.open(routeData.href, '_blank');
                  //新查看跳转






            },

            //导表
            outexcel() {

               updownfile.down('/api/swyl/v1/renewver/rateFormulaRenewVer/downloadExcel',this.q);

            },

            query() {

                ss.FormulaNew.rvlistshowPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })

            },
            handleDelete(q){

                console.log(q.rversion);
                this.$msg.confirm("确认删除?",()=>{
                    ss.FormulaNew.deleteH(q).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },

            handleFilter() {

                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },

        }
    }
</script>
<style>
   /* .h-formBorder .timeselect .el-form-item__content {
        line-height: 0.2rem;
    } */

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 28px;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }
</style>

